import { PaperWidthProvider } from '@contexts/PaperWidthProvider';
import { RegisterProvider } from '@contexts/RegisterProvider';
import { Outlet, useSearchParams } from 'react-router';

import { isValidRegistrationCode, sanitizeRegistrationCode } from './utils/registrationCodeUtils';

export default function RegisterPage() {
  const [params] = useSearchParams();
  const codeFromUrl = sanitizeRegistrationCode(params.get('code') || undefined);

  return (
    <RegisterProvider initialCode={isValidRegistrationCode(codeFromUrl) ? codeFromUrl : undefined}>
      <PaperWidthProvider>
        <Outlet />
      </PaperWidthProvider>
    </RegisterProvider>
  );
}
